import Icon from '../components/Icon.vue'

Icon.register({
  'ruler-vertical': {
    width: 256,
    height: 512,
    paths: [
      {
        d: 'M168 416h88v64c0 17.7-14.3 32-32 32h-192c-17.7 0-32-14.3-32-32v-448c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v64h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v64h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v64h-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler-vertical.js
// module id = 1852
// module chunks = 0